import { render, staticRenderFns } from "./message-content-input.vue?vue&type=template&id=298bc7c2&scoped=true"
import script from "./message-content-input.vue?vue&type=script&lang=js"
export * from "./message-content-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298bc7c2",
  null
  
)

export default component.exports